export enum PaymentStatus {
  NONE = 'NONE',
  ORDER_IN_PROGRESS = 'ORDER_IN_PROGRESS',
  PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  EXPIRED = 'EXPIRED',
  TIMEOUT = 'TIMEOUT',
}
export enum PaymentTypes {
  ONLINE = 'online',
  OTHER = 'other',
  NONE = '',
}

export type Payment = {
  orderNumber?: string;
  paymentStatus?: PaymentStatus;
  paymentType?: PaymentTypes;
  onlinePaymentRequired?: boolean;
  maxNumberOfTries?: number;
};
